import React from "react";

export const SingleWrapper = ({ className, children }) => {
  return !!className ? <div className={className}>{children}</div> : children;
};
